import { FC, useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import AuthSubHeader from "src/components/authSubHeader";
import DetailPageInfo from "src/components/detailPageInfo";
import FooterText from "../../components/footerText";

import UpdatePatientForm from "src/components/updatePatientForm";
import PatientPageCaseListing from "src/components/patientPageCaseListing";
// import DetailPageInfoEmpty from "src/components/detailPageInfoEmpty";
import KAMFAMNotes from "src/components/kamfamNotes";
import { PATIENT_DETAIL_CASE } from "src/constants/detailPageTable";
import AddNote from "src/components/modals/addNote";
import AddNonCaseNote from "src/components/modals/addNonCaseTreatment";
import RequestDateOfTreatment from "src/components/modals/requestDateOfTreatment";
import CancelTreatment from "src/components/modals/cancelTreatment";
import DocumentListing from "src/components/patientDetail/documentListing";

import useFetch from "src/hooks/useFetch";
import { LoaderContext } from "src/context/loaderContext";
import { APIEndpoints } from "src/types/apiTypes";
import { CaseObjectType, GlobalPatientDetailType } from "./types";
import { AuthContext } from "src/context/authContext";
import { handleNavigation } from "src/helpers";
import PracticeContactInfo from "src/components/practiceContactInfo";
import TableHeader from "src/components/tableHeader";
import { sortTableColumns } from "src/helpers/stats";
import { ColumnSortProps } from "src/components/tableHeader/types";
// import DetailPageInfoEmpty from "src/components/detailPageInfoEmpty";
// import { AuthContext } from "src/context/authContext";



const UpdatePatient: FC = (): JSX.Element => {
  const [caseListing, updateCaseListing] = useState<CaseObjectType[]>([]);
  const [sortingConfig, setSortingConfig] = useState<ColumnSortProps>({
    sort_by: '',
    direction: 'desc',
  });
  const [saveNoteModal, setDataforNoteModal] = useState<{ isModalVisible: boolean; caseId: number; }>({
    isModalVisible: false,
    caseId: 0,
  });
  const [showRequestTreatmentModal, setDataForRequestModalTreatment] = useState<{ isModalVisible: boolean; caseId: number; prescriptionId: number, bentype: string; investigated_at: string; }>({
    isModalVisible: false,
    caseId: 0,
    prescriptionId: 0,
    investigated_at: "",
    bentype: ''
  });
  const [cancelTreatmentModal, setDataForCancelModal] = useState<{ isModalVisible: boolean; caseId: number; prescriptionId: number }>({
    isModalVisible: false,
    caseId: 0,
    prescriptionId: 0
  });
  const [NonCaseNoteModal, setDataforNonCaseNoteModal] = useState<{ isModalVisible: boolean; patientId: number; }>({
    isModalVisible: false,
    patientId: 0,
  });

  const { patientId } = useParams();
  const { hideLoader } = useContext(LoaderContext);
  const { isManufacturer, defaultView } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();



  const { data: globalPatientDetails, error: globalPatientAPIError, mutate: fetchGlobalPatientDetails } =
    useFetch<GlobalPatientDetailType>(APIEndpoints.GET_GLOBAL_PATIENT_DETAIL_BY_ID, {}, { patientId: patientId });

  useEffect(() => {
    if (globalPatientDetails || globalPatientAPIError) {
      hideLoader();
      if (globalPatientDetails) {
        if (globalPatientDetails?.data?.case_list) {
          updateCaseListing(globalPatientDetails?.data?.case_list)
          setSortingConfig({direction:"desc",sort_by:""})
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalPatientDetails, globalPatientAPIError]);

  const refreshPatientDetails = () => {
    fetchGlobalPatientDetails({}, { patientId: patientId })
  }

  const toTitleCase = (str: string) => {
    return str
      .toLowerCase()
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const redirectDecision = () => {
    const isRedirectRequired = handleNavigation(defaultView, location.pathname);
    if (isRedirectRequired) {
      navigate(defaultView.includes("/") ? defaultView : `/${defaultView}`, { replace: true })
    } else {
      navigate(0)
    }
  }

  const changeIdOrder = (value: string) => {
    sortTableColumns(value, sortingConfig, setSortingConfig, caseListing, updateCaseListing)
  };

  return (
    <div className="container-fluid overflow-auto">
      <div className={`${isManufacturer ? " d-flex flex-column flex-fill" : "container container-short d-flex flex-column flex-fill"}`}>          
        <div className="row justify-content-center">
          <div className="col-12">
            <AuthSubHeader />

            {globalPatientDetails && globalPatientDetails.data ?
              <>
                <div className="cotainer-fluid mt-3">
                  <div className="row align-items-center">
                    {globalPatientDetails.data.patient_info ? (
                      <div className="col-12 col-lg-3">
                        <h1 className="fs-2 text-success mb-0">
                          {toTitleCase(`${globalPatientDetails.data.patient_info.firstname} ${globalPatientDetails.data.patient_info.middlename} ${globalPatientDetails.data.patient_info.lastname}`)}
                        </h1>
                      </div>
                    ) : (
                      <div className="col-12 col-lg-3">
                        <h1 className="fs-2 text-success mb-0"> Patient ID {patientId} </h1>
                      </div>
                    )}

                    {globalPatientDetails.data.info && (
                      <>
                        <div className="col-12 col-lg-3">
                          <p className="text-center mb-0">
                            <b>BIs:</b> {globalPatientDetails.data.info.bi},
                            <b>Treatments:</b> {globalPatientDetails.data.info.treatments}
                          </p>
                        </div>
                        <div className="col-12 col-lg-6">
                          <div className={`text-center background-color-${globalPatientDetails.data.info.status_color || 1}`}>
                            <p className="text-white fs-3 mb-0">
                              {globalPatientDetails.data.info.status_name}
                            </p>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>

                <div className="my-3">
                  {globalPatientDetails.data.patient_info && (
                    <UpdatePatientForm patientInfo={{ id: patientId || "", ...globalPatientDetails.data.patient_info }} />
                  )}
                </div>

                <div className="my-3">
                  {(globalPatientDetails.data.benefit_summary && globalPatientDetails.data.coverage_summary) ?
                    <DetailPageInfo
                      benefit_summary={globalPatientDetails.data.benefit_summary}
                      coverage_summary={globalPatientDetails.data.coverage_summary}
                    />
                    :
                    <></>
                  }
                </div>

                {globalPatientDetails && globalPatientDetails.data && globalPatientDetails.data.kam_fam_notes ? (
                  <div className="my-3">
                    <KAMFAMNotes
                      add_note={globalPatientDetails.data.kam_fam_notes.add_note}
                      caseId={globalPatientDetails.data.kam_fam_notes.case_id}
                      kamfamNotes={globalPatientDetails.data.kam_fam_notes.notes.map((item, index) => ({ id: index, description: item.desc, ...item }))}
                      updateKamfamNotes={() => { }}
                      refreshListing={()=>{refreshPatientDetails()}}
                    />
                  </div>
                ) : null}

                {globalPatientDetails && globalPatientDetails.data && globalPatientDetails.data.documents ? (
                  <DocumentListing documents={globalPatientDetails.data.documents} />
                ) : null}

                {globalPatientDetails.data.patient_info ?
                  <div className="my-3">
                    <PatientPageCaseListing
                      patientId={patientId || "0"}
                      patientName={
                        `${globalPatientDetails.data.patient_info.firstname} ${globalPatientDetails.data.patient_info.middlename} ${globalPatientDetails.data.patient_info.lastname}`
                      }
                      caseListing={globalPatientDetails.data.case_list}
                      refreshPatientDetails={refreshPatientDetails}
                    />
                  </div>
                  :
                  <div className="card my-4 rounded-1">
                    <div className="card-header bg-success-subtle">
                      <div className="row">
                        <div className="col-6">
                          <h4 className="mb-0 text-success">Cases</h4>
                        </div>
                        <div className="col-6 text-end">
                          <button 
                            className="btn btn-sm btn-green my-1"
                            onClick={() => { patientId && setDataforNonCaseNoteModal({ isModalVisible: true, patientId: parseInt(patientId) }) }}
                          >
                            <i className="fas fa-times" aria-hidden="true"></i>  Add Tx Date If No BI
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="card-body p-0">
                      <div className="table-responsive">
                        <table className="table table-striped mb-0">
                          <thead>
                            <tr className="text-center align-items-center">
                              {PATIENT_DETAIL_CASE.map((header, index) => (
                                <TableHeader
                                  key={index}
                                  classNames="bg-secondary-subtle fs-6 fw-bold"
                                  tableHeader={{
                                    ...header,
                                    width: header.label.toLowerCase().includes("name") ? "40%" : ""
                                  }}
                                  sortConfig={sortingConfig}
                                  changeIdOrder={changeIdOrder}
                                />
                              ))}
                            </tr>
                          </thead>

                          <tbody>
                            {caseListing.length > 0 ?
                              caseListing.map((data, index) => {
                                const isOffice = data.kam_fam_note?.type.toLowerCase().replace(/note/g, '').trim() === "office"
                                const isFam = data.kam_fam_note?.type.toLowerCase().replace(/note/g, '').trim() === "fam"
                                return (
                                  <tr key={index}>
                                    <td className="text-center align-middle fs-6">
                                      {data.indication.toLowerCase() === "other" ? (
                                        <p className="text-danger mb-0">{data.case_id}</p>
                                      ) : (
                                        <Link
                                          to={`/cases/${data.case_id}`}
                                          className="btn btn-link link-offset-0 link-offset-0-hover link-underline link-underline-opacity-0 link-underline-opacity-100-hover p-0 align-baseline user-select-text"
                                        >
                                          {data.case_id}
                                        </Link>
                                      )}
                                    </td>
                                    <td className="text-center align-middle fs-6">
                                      {data.created}
                                    </td>
                                    <td className="text-center align-middle fs-6">
                                      {data.treated}
                                    </td>
                                    <td className="text-center align-middle fs-6">
                                      {data.date_of_next_treatment}
                                    </td>
                                    <td className="text-center align-middle fs-6">
                                      <PracticeContactInfo 
                                        name={data.practice_name} 
                                        address={data.practice_full_address} 
                                        phone={data.practice_phone_number} 
                                        fax={data.practice_fax_number}
                                        indexKey={index}
                                      >
                                        <>{data.provider}</>
                                      </PracticeContactInfo>
                                    </td>
                                    <td className={`text-center text-light align-middle fs-6 background-color-${data.status_color}`}>
                                      {data.status}
                                    </td>
                                    <td className="text-center align-middle fs-6">
                                      {isManufacturer && data.indication.toLowerCase() === "other" ?
                                        <p className="text-black mb-0">No Action Available</p> :
                                        <>
                                          {data.next_steps && data.next_steps.length > 0 ?
                                            data.next_steps.map((step, index) => {
                                              switch (step) {
                                                case "Treated 1":
                                                  return (
                                                    <button
                                                      key={index} className="btn btn-green btn-sm rounded-0 m-1"
                                                      onClick={() => setDataForRequestModalTreatment({ isModalVisible: true, caseId: data.case_id, prescriptionId: data.prescription_id, bentype: "med", investigated_at: data.investigated_at || "" })}
                                                      type="button"
                                                    >
                                                      <i className="far fa-clipboard"></i> Treated
                                                    </button>
                                                  );
                                                case "Treated 2":
                                                  return (
                                                    <button
                                                      key={index} className="btn btn-green btn-sm rounded-0 m-1"
                                                      onClick={() => setDataForRequestModalTreatment({ isModalVisible: true, caseId: data.case_id, prescriptionId: data.prescription_id, bentype: "na", investigated_at: data.investigated_at || "" })}
                                                      type="button"
                                                    >
                                                      <i className="far fa-clipboard"></i> Treated
                                                    </button>
                                                  );
                                                case "Not Treating":
                                                  return (
                                                    <button 
                                                      key={index} className="btn btn-green btn-sm rounded-0 m-1"
                                                      onClick={() => setDataForCancelModal({ isModalVisible: true, caseId: data.case_id, prescriptionId: data.prescription_id })}
                                                      type="button"
                                                    >
                                                      <i className="fas fa-times" aria-hidden="true"></i>  Not Treating
                                                    </button>
                                                  );
                                                case "Not Treated":
                                                  return (
                                                    <button
                                                      key={index} className="btn btn-green btn-sm rounded-0 m-1"
                                                      onClick={() => setDataForCancelModal({ isModalVisible: true, caseId: data.case_id, prescriptionId: data.prescription_id })}
                                                      type="button"
                                                    >
                                                      <i className="fas fa-times" aria-hidden="true"></i>  Not Treating
                                                    </button>
                                                  );
                                                case "No Action Required":
                                                  return (<span>No Action Available</span>);
                                                default:
                                                  return (<div key={index}></div>);
                                              }
                                            })
                                          : null}
                                        </>
                                      }
                                    </td>
                                    <td className="text-center align-middle fs-6">
                                      {data.not_treated_reason ?
                                        <span>{data.not_treated_reason}</span>
                                      : null}
                                    </td>
                                    <td className={`text-center align-middle fs-6`}>
                                      {data.indication}
                                    </td>
                                    <td className="text-center align-middle fs-6">
                                      {data.indication.toLowerCase() !== "other" ?
                                        data.kam_fam_note && data.kam_fam_note.text === 'Add Note' ? (
                                          <button
                                            type="button" className="btn btn-green btn-sm rounded-0" disabled={!data.kam_fam_note.clickable}
                                            onClick={() => { setDataforNoteModal({ isModalVisible: true, caseId: data.case_id }) }}
                                          >
                                            <i className="fas fa-times"></i>{data.kam_fam_note.text}
                                          </button>
                                        ) : 
                                        (isManufacturer || !String(data.kam_fam_note?.text).includes("No FAM Action Needed"))
                                  ? (
                                    <button
                                      className={`btn btn-link ${isOffice ? "btn-office" : isFam ? "btn-fam" : ""} user-select-text`}
                                      onClick={() =>
                                        setDataforNoteModal({
                                          isModalVisible: true,
                                          caseId: data.case_id
                                        })
                                      }
                                    >
                                      {data.kam_fam_note?.text}
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      className="btn btn-green btn-sm rounded-0"
                                      onClick={() =>
                                        setDataforNoteModal({
                                          isModalVisible: true,
                                          caseId: data.case_id
                                        })
                                      }
                                    >
                                      <i className="fas fa-times me-1"></i> Add Note
                                    </button>
                                  )
                                      : 
                                      null}
                                    </td>
                                  </tr>
                                )
                              })
                            : null}
                            </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                }
              </>
            : null}
            <div className="mt-4"><FooterText/></div>
          </div>
        </div>
      </div>

      {saveNoteModal.isModalVisible ? (
        <AddNote
          isModalVisible={saveNoteModal.isModalVisible}
          caseId={saveNoteModal.caseId}
          refreshListing={() => fetchGlobalPatientDetails()}
          hideModal={() => {
            setDataforNoteModal({
              isModalVisible: false,
              caseId: 0,
            });
          }}
        />
      ) : null}

      <AddNonCaseNote
        isModalVisible={NonCaseNoteModal.isModalVisible}
        patientName={NonCaseNoteModal.patientId.toString()}
        refreshListing={() => fetchGlobalPatientDetails()}
        hideModal={() => {
          setDataforNonCaseNoteModal({
            isModalVisible: false,
            patientId: 0,
          });
        }}
      />

      <RequestDateOfTreatment
        isModalVisible={showRequestTreatmentModal.isModalVisible}
        caseId={showRequestTreatmentModal.caseId}
        prescriptionId={showRequestTreatmentModal.prescriptionId}
        bentype={showRequestTreatmentModal.bentype}
        investigated_at={showRequestTreatmentModal.investigated_at || ""}
        hideModal={() => {
          setDataForRequestModalTreatment({
            isModalVisible: false,
            caseId: 0,
            prescriptionId: 0,
            bentype: '',
            investigated_at: "",
          });
        }}
        refreshListing={() => redirectDecision()}
      />

      <CancelTreatment
        isModalVisible={cancelTreatmentModal.isModalVisible}
        caseId={cancelTreatmentModal.caseId}
        prescriptionId={cancelTreatmentModal.prescriptionId}
        hideModal={() => {
          setDataForCancelModal({
            isModalVisible: false,
            caseId: 0,
            prescriptionId: 0
          });
        }}
        refreshListing={() => redirectDecision()}
      />
    </div>
  );
};

export default UpdatePatient;
